/**
 * DeployLogs.js
 *
 * Thin wrapper around the shared LogsViewer component for deployment logs.
 *
 * WHY THIS EXISTS:
 * - Maintains backward compatibility with existing usages
 * - Maps deployId prop to entityId
 * - Sets entityType='deploy' automatically
 *
 * MIGRATION NOTE:
 * This is now a wrapper around LogsViewer. All features (auto-refresh, search,
 * date filtering, pagination) are inherited from LogsViewer.
 */

import React from 'react';
import PropTypes from 'prop-types';
import LogsViewer from './LogsViewer';

/**
 * DeployLogs - Display logs from a deployment
 *
 * @param {string} deployId - ID of the deployment to fetch logs for
 * @param {function} getApiToken - Function that returns an auth token
 * @param {boolean} expanded - Whether the logs section is expanded
 * @param {function} onToggle - Callback when expand/collapse is triggered
 */
const DeployLogs = ({
  deployId,
  getApiToken,
  expanded = false,
  onToggle,
  hideToggleButton = false,
}) => {
  return (
    <LogsViewer
      entityId={deployId}
      entityType="deploy"
      getApiToken={getApiToken}
      expanded={expanded}
      onToggle={onToggle}
      hideToggleButton={hideToggleButton}
      enableDateFilter={true}
      enableSearch={true}
      enableAutoRefresh={true}
      enableLimitSelector={true}
      defaultLimit={500}
    />
  );
};

DeployLogs.propTypes = {
  deployId: PropTypes.string.isRequired,
  getApiToken: PropTypes.func.isRequired,
  expanded: PropTypes.bool,
  onToggle: PropTypes.func,
  hideToggleButton: PropTypes.bool,
};

export default DeployLogs;
